import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Strip from "../customComponent/Strip/Strip";
import ExternalLayout from "../customComponent/ExternalLayout/ExternalLayout";
import RenderPage from "../customComponent/RenderPage/RenderPage";
import SEOComponent from "../customComponent/SEO/SEOComponent";
import CustomPagination from "./Home/CustomPagination";
import DevicesData from "../Utils/Json/DevicesData";

const Devices = () => {
  const [width] = useWindowSize();
  const [data, setData] = useState([]);
  const [Patient_id, setPatient_id] = useState("");
  const [patient, setPatient] = useState({
    patient_id: "",
    firstname: "",
    lastname: "",
    dob: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 10; // Change this to the number of cards per page
  const totalCards = DevicesData.length; // Assuming 'data' is the array of cards
  const totalPages = Math.ceil(totalCards / cardsPerPage);


  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

 

  return (
    <ExternalLayout>
      <RenderPage
        id="tst-landing"
        className={`render px-0 render-page`}
        containerType="container-fluid"
      >
        <Strip
          id="tst-strip-Video"
          className="strip strip-no-padding "
          containerType="container-fluid mb-5 mt-5"
        >
         <SEOComponent
            title="Patients"
            keywords="Patients"
            description="Antlia"
            siteUrl="/Antlia"
          />
          <Row className="mx-0 background-container container mx-5">
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={11}
              className="m-auto pt-4 "
            >
              <Row>
                 
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pt-3 pl-5">
                
                
                  <p className="p-small title-bold2 align-left">
                    <span className="p-small section-title title-bold1">
                      Devices
                    </span>
                   
                  </p>
                  <p className="pt-3">
                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    resultsPerPage={cardsPerPage}
                    totalPatients={totalCards}
                    />
                  </p>
                         
                            <table className="custom-table section-title p-5">
      <thead>
        <tr className="pl-5">
        <th className="p-lesserthan-small">Device Type</th>
          <th className="p-lesserthan-small">ID</th>
          <th className="p-lesserthan-small">Status</th>
          <th className="p-lesserthan-small">Hospital</th>
          <th className="p-lesserthan-small">Doctor Name</th>
          <th className="p-lesserthan-small">Last Service Date</th>
          
        </tr>
      </thead>
      <tbody>
        
      {DevicesData.map((row) => (
          <tr key={row.type}>
          <td className="p-lesserthan-small">{row.type}</td>
            <td className="p-lesserthan-small">{row.ID}</td>
            <td className="status-dot"><span class="dot green"></span></td>
            <td className="p-lesserthan-small">{row.name}</td>
            <td className="p-lesserthan-small">{row.doctor}</td>
            <td className="p-lesserthan-small">{row.date}</td>
            
          </tr>
        ))}
       
      </tbody>
    </table>
                          
                        
                     
                </Col>
              </Row>
            </Col>
          </Row>
          );
        </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

export default Devices;
